import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import React, { FC } from "react";
import { DropdownListItemProps } from "shared/components/DropdownList";
import { COLOR_WHITE, COLOR_GREY_8 } from "shared/theme/colors";
import {
  StyledDropdownList,
  StyledText,
  StyledTitleContainer,
  StyledUser,
} from "./styled";

export type UserProps = Partial<{
  title?: string;
  subtitle?: string;
  dropdown?: DropdownListItemProps[];
  dropdownIcon?: React.ReactNode;
  isExpanded?: boolean;
}>;

const User: FC<UserProps> = (props) => (
  <StyledUser>
    <Collapse
      in={props.isExpanded}
      timeout="auto"
      unmountOnExit
      orientation="horizontal"
    >
      <StyledTitleContainer>
        <StyledText variant="bodyLMedium" color={COLOR_WHITE}>
          {props.title}
        </StyledText>
        {props.subtitle && (
          <StyledText variant="bodySRegular" color={COLOR_GREY_8}>
            {props.subtitle}
          </StyledText>
        )}
      </StyledTitleContainer>
    </Collapse>
    {props.dropdown && (
      <Box ml=".25rem" mt={props.isExpanded ? "0" : "1.5rem"}>
        <StyledDropdownList
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          items={props.dropdown}
          icon={props.dropdownIcon}
        />
      </Box>
    )}
  </StyledUser>
);

export default User;
